import { render, staticRenderFns } from "./FooterMainMenuItem.vue?vue&type=template&id=dafe6690"
import script from "./FooterMainMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterMainMenuItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLink: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiLink.vue').default})
